import { render } from "./CompareProduct.vue?vue&type=template&id=3c7129bf"
import script from "./CompareProduct.vue?vue&type=script&lang=js"
export * from "./CompareProduct.vue?vue&type=script&lang=js"

import "./CompareProduct.vue?vue&type=style&index=0&id=3c7129bf&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__